import React, { forwardRef, MouseEvent, useEffect } from "react";

import {
    ButtonProvider,
    ButtonProviderProps,
    getIconColor,
    getTextColor,
    Icon,
    IconProps,
    IconTextColor,
    Layout,
    SpacingSize,
    Text,
} from "@multiweb/reactComponents";
//import { INodeAction } from "../../../UI.Controls/Actions/INodeAction";
import { IconCode } from "@multiweb/types/contracts";
import { ForwardRefType } from "@multiweb/types/react";
import { getIconWidth, getToolbarBtnWidth } from "./utils";

const DROP_DOWN_ICON = IconCode.uiTriangleBottom;

/* eslint-disable react-redux/no-unused-prop-types */
export type ToolbarGroupItemProps = {
    /** Popisek pro bližší popis tlačítka */
    title?: string;
    /** Barva ikony a textu */
    color?: IconTextColor;
    /** Callback volaný na kliknutí */
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    /** Text tlačítka */
    value?: string;
    /** Pošle info o své velikosti */
    onSizeCallback?: (size: number) => void;
    /** Obsahuje nodeAction tedy seznam akci  */
    nodeAction?: boolean; // INodeAction; // TODO: Jen pro otestovani ve StoryBooku, čeka až bude zpracován WI 35685, kde by se měl řešít React DropDown, který určí jakým způsobem se budou akce vůbec předávat.
    /** Ikona */
    iconCode?: IconCode;
} & Omit<ButtonProviderProps, "title" | "onClick"> & Omit<IconProps, "title" | "color" | "iconCode">;

export const ToolbarGroupItem: ForwardRefType<HTMLButtonElement, ToolbarGroupItemProps> = forwardRef<HTMLButtonElement, ToolbarGroupItemProps>(({
    title,
    color = IconTextColor.colorPrimary,
    onClick,
    isFocused,
    tabIndex,
    disabled,
    onSizeCallback,
    value,
    nodeAction,
    iconCode,
    ...restProps
}, ref) => {
    useEffect(() => {
        let toolbarItemWidth = 0;

        if (value) {
            toolbarItemWidth += getToolbarBtnWidth(value);
        }

        if (iconCode) {
            toolbarItemWidth += getIconWidth(iconCode, false);
        }
        if (nodeAction) {
            toolbarItemWidth += getIconWidth(DROP_DOWN_ICON, false);
        }

        onSizeCallback && onSizeCallback(toolbarItemWidth);
    }, [value, onSizeCallback, iconCode, nodeAction]);

    return (
        <ButtonProvider {...{ onClick, title, ref, disabled, tabIndex, isFocused }}>
            {iconCode && <Layout spacingSize={SpacingSize.xs} spacingSizeRight={value ? SpacingSize.none : SpacingSize.xs}>
                <Icon color={getIconColor(color)} disabled={disabled} iconCode={iconCode} {...restProps} />
            </Layout>}
            {value && <Layout spacingSize={SpacingSize.xs}>
                <Text color={getTextColor(color)} disabled={disabled} isTextSelectable={false} value={value} {...restProps} />
            </Layout>}
            {nodeAction && // TODO: Doplnit dropdownMenu az bude hotove
            <Layout spacingSize={SpacingSize.xs} spacingSizeLeft={SpacingSize.none}>
                <Icon color={getIconColor(color)} disabled={disabled} iconCode={DROP_DOWN_ICON} {...restProps} />
            </Layout>}
        </ButtonProvider>);
});
